import * as React from "react";
import WorkflowSidebar from "./WorkflowSidebar";
class WorkflowsHome extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
  }
  componentWillUnmount() {
  }
  componentDidUpdate() {
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "sidebarLayout d-flex flex-row flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "sidebar-container" }, /* @__PURE__ */ React.createElement(WorkflowSidebar, null)), /* @__PURE__ */ React.createElement("div", { className: "flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "h-100 d-flex align-items-center" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "p-2 col-example",
        style: {
          textAlign: "center",
          marginLeft: "100px",
          marginRight: "100px",
          width: "60%"
        }
      },
      /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-sitemap", size: "6x" }),
      /* @__PURE__ */ React.createElement(
        "h2",
        {
          style: {
            fontWeight: "bolder",
            fontStyle: "italic",
            margin: "16px"
          }
        },
        "Workflows"
      )
    ))));
  }
}
export default WorkflowsHome;
